import React from 'react';
const SvgDotxThumbnail = React.forwardRef((rest, ref) => {
  const props = { ...rest, ref };
  return (
    <svg viewBox="0 0 96 96" width="1em" height="1em" {...props}>
      <path fill="#FFF" d="M82 10V6H24v78h6v6h58V12z" />
      <path fill="#2B579A" d="M82 6H24v12h58v-8l6 6v-4z" />
      <path fill="#949494" d="M86 14v74H32v-4h50V18h-2v64H26V18h-2v66h6v6h58V16z" />
      <path
        fill="#C8C8C8"
        d="M32 22h10v2H32zM48 32h26v2H48zM48 38h26v2H48zM48 44h26v2H48zM48 50h26v2H48zM48 56h26v2H48zM48 62h26v2H48zM48 68h26v2H48zM48 74h26v2H48z"
      />
      <path fill="#2B579A" d="M8 34l40-6v52L8 74z" />
      <path
        fill="#FFF"
        d="M42 45l-5.248 20h-4.958l-3.296-12.831a10.733 10.733 0 01-.318-2.246h-.055c-.083.912-.204 1.66-.36 2.246L24.385 65h-5.164L14 45h4.888l2.797 13.32c.12.567.208 1.33.264 2.287h.083c.036-.716.17-1.497.401-2.343L26.033 45h4.792l3.254 13.431c.12.493.226 1.209.319 2.148h.055c.037-.734.133-1.479.29-2.232L37.487 45H42z"
      />
      <linearGradient id="dotx-thumbnail_svg__a" gradientUnits="userSpaceOnUse" x1={28} y1={78.375} x2={28} y2={29.517}>
        <stop offset={0} stopColor="#fff" stopOpacity={0} />
        <stop offset={0.859} stopColor="#fff" stopOpacity={0.155} />
        <stop offset={1} stopColor="#fff" stopOpacity={0.18} />
      </linearGradient>
      <path fill="url(#dotx-thumbnail_svg__a)" d="M48 28L8 34v40l40 6z" />
      <linearGradient
        id="dotx-thumbnail_svg__b"
        gradientUnits="userSpaceOnUse"
        x1={35.508}
        y1={85.837}
        x2={36.355}
        y2={77.86}
      >
        <stop offset={0} stopColor="#828282" stopOpacity={0} />
        <stop offset={0.17} stopColor="#7e7e7e" stopOpacity={0.034} />
        <stop offset={0.346} stopColor="#717171" stopOpacity={0.069} />
        <stop offset={0.525} stopColor="#5d5d5d" stopOpacity={0.105} />
        <stop offset={0.706} stopColor="#404040" stopOpacity={0.141} />
        <stop offset={0.886} stopColor="#1b1b1b" stopOpacity={0.178} />
        <stop offset={0.997} stopOpacity={0.2} />
      </linearGradient>
      <path fill="url(#dotx-thumbnail_svg__b)" d="M48 86H24v-9.6L48 80z" />
      <linearGradient
        id="dotx-thumbnail_svg__c"
        gradientUnits="userSpaceOnUse"
        x1={25.998}
        y1={16.439}
        x2={80.002}
        y2={85.561}
      >
        <stop offset={0} stopColor="#fff" stopOpacity={0} />
        <stop offset={0.226} stopColor="#fcfcfc" stopOpacity={0.023} />
        <stop offset={0.363} stopColor="#f4f4f4" stopOpacity={0.036} />
        <stop offset={0.475} stopColor="#e6e6e6" stopOpacity={0.048} />
        <stop offset={0.574} stopColor="#d1d1d1" stopOpacity={0.057} />
        <stop offset={0.665} stopColor="#b7b7b7" stopOpacity={0.067} />
        <stop offset={0.75} stopColor="#979797" stopOpacity={0.075} />
        <stop offset={0.83} stopColor="#707070" stopOpacity={0.083} />
        <stop offset={0.906} stopColor="#444" stopOpacity={0.091} />
        <stop offset={0.976} stopColor="#121212" stopOpacity={0.098} />
        <stop offset={1} stopOpacity={0.1} />
      </linearGradient>
      <path fill="url(#dotx-thumbnail_svg__c)" d="M24 18h58v66H24z" />
      <linearGradient
        id="dotx-thumbnail_svg__d"
        gradientUnits="userSpaceOnUse"
        x1={46.856}
        y1={37.457}
        x2={87.943}
        y2={90.045}
      >
        <stop offset={0} stopColor="#fff" stopOpacity={0} />
        <stop offset={0.226} stopColor="#fcfcfc" stopOpacity={0.023} />
        <stop offset={0.363} stopColor="#f4f4f4" stopOpacity={0.036} />
        <stop offset={0.475} stopColor="#e6e6e6" stopOpacity={0.048} />
        <stop offset={0.574} stopColor="#d1d1d1" stopOpacity={0.057} />
        <stop offset={0.665} stopColor="#b7b7b7" stopOpacity={0.067} />
        <stop offset={0.75} stopColor="#979797" stopOpacity={0.075} />
        <stop offset={0.83} stopColor="#707070" stopOpacity={0.083} />
        <stop offset={0.906} stopColor="#444" stopOpacity={0.091} />
        <stop offset={0.976} stopColor="#121212" stopOpacity={0.098} />
        <stop offset={1} stopOpacity={0.1} />
      </linearGradient>
      <path fill="url(#dotx-thumbnail_svg__d)" d="M82 10v74H30v6h58V16z" />
      <linearGradient id="dotx-thumbnail_svg__e" gradientUnits="userSpaceOnUse" x1={56} y1={89.813} x2={56} y2={84.175}>
        <stop offset={0} stopColor="#828282" stopOpacity={0} />
        <stop offset={0.281} stopColor="#7f7f7f" stopOpacity={0.028} />
        <stop offset={0.45} stopColor="#777" stopOpacity={0.045} />
        <stop offset={0.59} stopColor="#696969" stopOpacity={0.059} />
        <stop offset={0.713} stopColor="#545454" stopOpacity={0.071} />
        <stop offset={0.826} stopColor="#3a3a3a" stopOpacity={0.083} />
        <stop offset={0.929} stopColor="#1a1a1a" stopOpacity={0.093} />
        <stop offset={1} stopOpacity={0.1} />
      </linearGradient>
      <path fill="url(#dotx-thumbnail_svg__e)" d="M30 84h52v6H30z" />
      <linearGradient
        id="dotx-thumbnail_svg__f"
        gradientUnits="userSpaceOnUse"
        x1={55.678}
        y1={17.154}
        x2={56.331}
        y2={4.68}
      >
        <stop offset={0} stopColor="#fff" stopOpacity={0} />
        <stop offset={0.854} stopColor="#fff" stopOpacity={0.213} />
        <stop offset={1} stopColor="#fff" stopOpacity={0.25} />
      </linearGradient>
      <path fill="url(#dotx-thumbnail_svg__f)" d="M82 6H24v12h58v-8l6 6v-4z" />
    </svg>
  );
});
export default SvgDotxThumbnail;
SvgDotxThumbnail.iconName = 'dotx-thumbnail';
SvgDotxThumbnail.displayName = 'SvgDotxThumbnail';
